export const API_VERSION_PREFIX = "/v1" as const;

/** Every game on the platform (folder name = subdomain, `apps/arcade/src/games/<id>`). */
export const GAME_IDS = [
  "mozaik", "carsi", "raf", "kacis", "akis", "blok", "yanki", "harf-yilani", "baskent", "zaman", "harf-kulesi", "duvar", "kosu",
] as const;
export type GameId = (typeof GAME_IDS)[number];

export const API_ERROR_CODES = [
  "AUTH_REQUIRED",
  "SESSION_EXPIRED",
  "INVALID_PAYLOAD",
  "NOT_FOUND",
  "FORBIDDEN",
  "RATE_LIMITED",
  "REVISION_CONFLICT",
  "INTERNAL_ERROR",
  "PHONE_INVALID",
  "CODE_INVALID",
  "CODE_EXPIRED",
  "SMS_FAILED",
  "AGE_REQUIRED",
] as const;
export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

export interface ApiErrorEnvelope {
  error: {
    code: ApiErrorCode;
    message: string;
    requestId: string;
  };
}

export interface HealthResponse {
  status: "ok";
}

export type DependencyStatus = "ready" | "unconfigured" | "unavailable";

export interface ReadinessResponse {
  status: "ready" | "not_ready";
  dependencies: {
    postgres: DependencyStatus;
    redis: DependencyStatus;
  };
}

export interface Viewer {
  publicId: string;
  /** False once a phone is linked (progress is kept across devices). */
  guest: boolean;
  displayName: string;
  avatarKey: string;
  /** `+90 5•• ••• •• 21` when a phone is linked. */
  phoneHint?: string;
  /** The player's latest answer to "may we write to you on WhatsApp?". */
  whatsappOptIn?: boolean;
}

export interface ReplayEnvelope<TResult = unknown, TMove = unknown> {
  gameId: GameId;
  mode: string;
  level?: number;
  seed: string;
  rulesetVersion: string;
  gameBuildVersion: string;
  moves: TMove[];
  claimedResult: TResult;
}

export * from "./identity.js";
export * from "./social.js";
export * from "./account.js";
